export const SET_CAN_CONTINUE_TRUE = 'SET_CAN_CONTINUE_TRUE';
export const setCanContinueTrue = () => {
  return{
    type: SET_CAN_CONTINUE_TRUE
  }
}

export const SET_CAN_CONTINUE_FALSE = 'SET_CAN_CONTINUE_FALSE';
export const setCanContinueFalse = () => {
  return {
    type: SET_CAN_CONTINUE_FALSE
  }
}